module.exports = __webpack_public_path__ + "assets/img/me.4421e15f.png";